import regions from "../assets/data/regions.json";

export function getIndicator(indicatorId) {
  let extra = "";
  // if (["WIFEBEATING", "UNMETNEED"].includes(indicatorId)) extra = ".x";
  return indicatorId.toLowerCase() + extra;
}

export function getIndicatorLow(indicatorId) {
  return "ci_l_" + getIndicator(indicatorId);
}

export function getIndicatorUp(indicatorId) {
  return "ci_u_" + getIndicator(indicatorId);
}

export function getIndicatorNumber(indicatorId) {
  return "ci_u_" + getIndicator(indicatorId) + "_count";
}

export function getNumber(num) {
  if (num === "NA") return null;
  return +num;
}

export function capitalize(val) {
  if (!val) return "";
  return val.charAt(0).toUpperCase() + val.slice(1);
}

export function getCitationNumbers(markdown) {
  let escaped = escapeHtml(markdown);

  // LINKS - FECYT
  const re = /\(([^)]+)\)/g;

  const replacements = [...escaped.matchAll(re)];

  return replacements.map((e) => e[1]);
}

function escapeHtml(html) {
  return html
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function regionsToCountries() {
  let countries = {};
  regions.forEach((region) => {
    region.countries.forEach((country) => {
      countries[country] = region.id;
    });
  });
  return countries;
}
